/**
* jv.candidate.details.workflow.offerLetter.Send Module
*
* Description
*/
angular.module('jv.candidate.details.workflow.offerLetter.send.controller', [])
    .controller('jvCandidateDetailsWorkflowOfferLetterSendController', ['$scope', '$routeParams', 'candidates', '$location', '$compile', '$rootScope','$localStorage', 'docuSignSvc','$window','jvHireUrlService',
        function($scope, $routeParams, candidates, $location, $compile, $rootScope, $localStorage, docuSignSvc, $window, jvHireUrlService){
            $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
            $scope.flags.loading = true;
            $scope.localStorage = $localStorage;
            $scope.localStorage.offerLetters = $scope.localStorage.offerLetters || {};
            $scope.docuSign={
                error: false,
                validationError: false
            };
            $scope.myaccountDocuSign = false;

            $scope.initiateOfferLetterProcessing = function(response) {
                var model = response.offerSummary.model;
                $scope.offerLetterMsg = $scope.processOfferLetterDetails(model, '');

                if($scope.localStorage.offerLetters) {
                    var companySignerKey = '';
                    if($scope.offerLetterMsg.docTemplate) {
                        companySignerKey = $scope.offerLetterMsg.docTemplate.EId;
                        } else if($scope.offerLetterMsg.file) {
                        companySignerKey = $scope.offerLetterMsg.file.EId;
                    }
                    var offerLetterObj = $scope.localStorage.offerLetters[companySignerKey];
                    if(angular.isDefined(offerLetterObj)){
                        $scope.companySigner = offerLetterObj.users;
                        $scope.companySignerObject = offerLetterObj.userObjs[0];
                        $scope.selectedSigningOrder = offerLetterObj.signingOrder;
                    }
                }

                if (['ESigGenerated', 'ESigUploaded'].includes($scope.offerLetterMsg.offerKind) && model.showSigningOrder && $scope.companySigner !== null && $scope.companySigner.length>0) {
                    $scope.offerLetterMsgEsig = $scope.processOfferLetterDetails(model, 'ESig');
                    $scope.showDoubleForm = true;
                    //candidate msg
                    $scope.setupSignatoryDetails($scope.offerLetterMsg, 'candidate', $scope.selectedSigningOrder === 'candidate'? 'first' : 'second');
                    //company msg
                    $scope.setupSignatoryDetails($scope.offerLetterMsgEsig, 'company', $scope.selectedSigningOrder === 'candidate'? 'second' : 'first');

                } else {
                    $scope.showDoubleForm = false;
                    //in non-esig, need to default to second for ease of maintenance
                    $scope.setupSignatoryDetails($scope.offerLetterMsg, 'candidate', 'second');
                }
            };

            $scope.processOfferLetterDetails = function(model, keyPrefix) {
                return {
                    file: model['offerLetter' + keyPrefix],
                    pdfFile: model['pdfOfferLetter' + keyPrefix],
                    docTemplate: model['documentTemplate' + keyPrefix],
                    offerKind: model['offerKind' + keyPrefix],
                    agencyUser: model['agencyUser'],
                    subject: model['offerLetterMessage' + keyPrefix].subject,
                    clone_content: angular.copy(model['offerLetterMessage' + keyPrefix].content),
                    attachments: model['offerLetterMessage' + keyPrefix].attachments,
                    bcc: model['offerLetterMessage'].bcc, // We will always prefill the CC field (global field now) from `offerLetterMessage` (candidate form) (ALPHA-3772 - Make CC field global for two forms).
                    ccToCompletion: true
                };
            };

            $scope.setupSignatoryDetails = function(offerLetter, assigneeType, key) {
                $scope[key] = {
                    subject: offerLetter.subject,
                    signingOrder: $scope.selectedSigningOrder,
                    content: offerLetter.clone_content,
                    companyESigners: $scope.companySigner,
                    attachmentList: [],
                    bccList: [],
                    bcc: offerLetter.bcc,
                    attachments: offerLetter.attachments,
                    ccToOfferCompletion: true
                };

               if (assigneeType === 'candidate') {
                    $scope[key].firstName = $scope.appDetails.application.candidate.firstName;
                    $scope[key].lastName = $scope.appDetails.application.candidate.lastName;
                    $scope[key].toList = [$scope.appDetails.application.candidateEId];
                } else {
                    $scope[key].firstName = $scope.companySignerObject.firstName;
                    $scope[key].lastName = $scope.companySignerObject.lastName;
                    $scope[key].toList = $scope.companySigner;
                }
            };

            var readMode = 0;
            // get the company signer email
            $scope.getCompanySignerEId = function() {
                 let obj = $scope.localStorage.offerLetters;
                 let offerTemplates = $scope.localStorage.offerGenerated;
                 if (angular.isDefined(offerTemplates)
                 && angular.isDefined($scope.appDetails)
                 && angular.isDefined($scope.appDetails.application)
                 && angular.isDefined($scope.appDetails.application.EId)) {
                  let offerTemplateEId = offerTemplates[$scope.appDetails.application.EId];
                  if (angular.isDefined(obj) && angular.isDefined(offerTemplateEId)
                      && angular.isDefined(obj[offerTemplateEId]) && angular.isDefined(obj[offerTemplateEId].userObjs)
                      && angular.isDefined(obj[offerTemplateEId].userObjs[0])
                      && angular.isDefined(obj[offerTemplateEId].userObjs[0].EId)) {
                      return obj[offerTemplateEId].userObjs[0].EId;
                     }
                 }
                 return null; // Return null if no matching email is found
            };

            candidates.getOfferLetter($routeParams.applicationId, $routeParams.stateId, readMode, $scope.getCompanySignerEId(), function(res){
                $scope.initiateOfferLetterProcessing(res);

                    if ($scope.first.attachments && $scope.first.attachments.length > 1) {
                        var defaultAttachmentListESig = angular.copy($scope.first.attachments);
                        $scope.first.attachments = {}; // Ensure initialization

                        angular.forEach(defaultAttachmentListESig, function (value, key) {
                            if (key !== 0) {
                                $scope.first.attachments[value.EId] = {
                                    resourceInfo: defaultAttachmentListESig[key]
                                };
                            }
                        });

                        var uploaderLoadedESig = $('#Attachment-uploader-esig .qq-upload-list');

                        angular.forEach(defaultAttachmentListESig, function (value, idx) {
                            if (idx !== 0) {
                                $compile(
                                    uploaderLoadedESig.append('<div class="qq-upload-success' + idx + '"><span class="qq-upload-file">' + value.fileName + '</span><span class="qq-upload-size" style="display:inline"></span><a ng-click="deleteDefaultAttachmentsESig(\'' + value.EId + '\', ' + idx + ');" class="icon icon-delete upload-file-delete actn-delete" style="disply:inline-block">&nbsp;</a></div>')
                                )($scope);
                            }
                        });

                        $scope.deleteDefaultAttachmentsESig = function (attachmentId, index) {
                            if ($scope.first.attachments[attachmentId]) {
                                delete $scope.first.attachments[attachmentId];
                                $('#Attachment-uploader-esig .qq-upload-success' + index).remove();
                            }
                        };
                    }

                if($scope.second && $scope.second.attachments && $scope.second.attachments.length > 1){
                        var defaultAttachmentList = angular.copy($scope.second.attachments);
                        $scope.secondAttachments = {};

                        angular.forEach(defaultAttachmentList, function(value, key){
                            if(key !== 0){
                                $scope.secondAttachments[value.EId] = {
                                    resourceInfo: defaultAttachmentList[key]
                                };
                            }
                        });


                      setTimeout(function() { var uploaderLoaded = $('#Attachment-uploader-second .qq-upload-list');

                        angular.forEach(defaultAttachmentList, function(value, idx){
                            if(idx !== 0){
                                $compile(
                                    uploaderLoaded.append('<div class="qq-upload-success'+idx+'"><span class="qq-upload-file">'+value.fileName+'</span><span class="qq-upload-size" style="display:inline"></span><a ng-click="deleteDefaultAttachments(\''+value.EId+'\', '+idx+');" class="icon icon-delete upload-file-delete actn-delete" style="disply:inline-block">&nbsp;</a></div>')
                                )($scope);
                            }
                        });

                        $scope.deleteDefaultAttachments = function(attachmentId, index){
                            if($scope.secondAttachments[attachmentId]){
                                delete $scope.secondAttachments[attachmentId];
                                $('#Attachment-uploader-second .qq-upload-success'+index).remove();
                            }
                        };
                    }, 1);
                }

                    if($scope.offerLetterMsg.pdfFile){
                        $scope.offerLetterMsg.sendPDFOLetter = true;
                    }else{
                        $scope.offerLetterMsg.sendOLetter = true;
                    }

                $scope.flags.loading = false;

            });

            $scope.changeContent = function(){
                $scope.offerLetterMsg.clone_content = $scope.offerLetterMsg.printOfferLetter ? '' : $scope.offerLetterMsg.content;
            };

            $scope.changeESigContent = function(){
                $scope.offerLetterMsgEsig.clone_content = $scope.offerLetterMsgEsig.printOfferLetter ? '' : $scope.offerLetterMsgEsig.content;
            };

            $scope.downloadOfferLetter = function(fileId){
                if($scope.offerLetterMsg.file){
                    var data = {
                        applicationId: $routeParams.applicationId,
                        fId: fileId,
                        readMode: readMode
                    };
                    window.open('../../action/resource/' + data.applicationId + '/offer/' + data.fId + '?readMode=' + data.readMode, '_blank');
                }
                else{
                    $scope.offerLetterMsg.error = true;
                }
            };

            $scope.downloadOfferLetterEsig = function(fileId){
                if($scope.offerLetterMsgEsig.file){
                    var data = {
                        applicationId: $routeParams.applicationId,
                        fId: fileId,
                        readMode: readMode
                    };
                    window.open('../../action/resource/' + data.applicationId + '/offer/' + data.fId + '?readMode=' + data.readMode, '_blank');
                }
                else{
                    $scope.offerLetterMsg.error = true;
                }
            };

            $scope.isNullOrEmpty = function(obj){
                if(!obj){
                    return true;
                }

                if(typeof(obj) === 'string' && obj.length === 0){
                    return true;
                }

                return false;
            };

        //  FUTURE PURPOSE
            $scope.cancel=function(flag){
                $scope[flag]=false;
            };

            $scope.saveDocuSign = function(data, flag){
                delete $scope.docuSign.error;
                $scope.docuSign.validationError = false;

                if($scope.isNullOrEmpty(data.username) || $scope.isNullOrEmpty(data.password) || $scope.isNullOrEmpty(data.accountId)){
                    $scope.docuSign.validationError = true;
                    return;
                }

                docuSignSvc.saveDocuSign(data, flag, function(res){
                    if(res.data.docuSignOAuthStatus){
                        if(res.data.docuSignOAuthStatus.errorCode === 'OK'){
                            $scope.cancel('myaccountDocuSign');
                            $scope.sendOfferLetter();
                        }else{
                            $scope.docuSign.error=res.data.docuSignOAuthStatus.message;
                        }
                    }
                });
            };

            $scope.sendOfferLetter= function(){
                var data = {
                    content: $scope.second.content,
                    subject: $scope.second.subject,
                    toList: [],
                    bccList: [],
                    attachmentList: []
                };

                $scope.flags.loading=true;
                if($scope.offerLetterMsg.printOfferLetter && $scope.offerLetterMsg.notifyOthers)
                {
                    if($scope.offerLetterMsg.to)
                    {
                        for(var k=0; k<$scope.offerLetterMsg.to.length; k++){
                            data.toList[k] = $scope.offerLetterMsg.to[k].EId;
                        }
                    }
                    else
                    {
                        return false;
                    }
                }
                else if(!$scope.offerLetterMsg.printOfferLetter){
                    data.toList.push($scope.appDetails.application.candidateEId);

                    if($scope.secondAttachments){
                        for(let x in $scope.secondAttachments){
                            data.attachmentList.push(x);
                        }
                    }

                    var isESigOffer = ($scope.offerLetterMsg.offerKind === 'ESigGenerated' || $scope.offerLetterMsg.offerKind === 'ESigUploaded');
                    //In case of eSig offers, offer letter document is not included as attachment.
                    if(!isESigOffer && $scope.offerLetterMsg.sendOLetter && $scope.offerLetterMsg.attachments && $scope.offerLetterMsg.attachments.length > 0){
                        data.attachmentList.push($scope.offerLetterMsg.attachments[0].EId);
                    }

                    if($scope.offerLetterMsg.sendPDFOLetter && $scope.offerLetterMsg.pdfFile && $scope.offerLetterMsg.pdfFile.EId){
                        data.attachmentList.push($scope.offerLetterMsg.pdfFile.EId);
                    }

                    if($scope.offerLetterMsg.attachments && $scope.offerLetterMsg.attachments.length > 1){
                        for(var i=1; i<$scope.offerLetterMsg.attachments.length; i++){
                            if($scope.offerLetterMsg.attachments[i].selected){
                                data.attachmentList.push($scope.offerLetterMsg.attachments[i].EId);
                            }
                        }
                    }

                    //agency user is CC'd by default in case of agency applications.
                    if ($scope.offerLetterMsg.agencyUser) {
                        data.bccList.push($scope.offerLetterMsg.agencyUser.EId);
                    }
                    if ($scope.second.bcc) {
                      for (let j = 0; j < $scope.second.bcc.length; j++) {
                        data.bccList.push($scope.second.bcc[j].EId);
                      }
                    }
                }

                if($scope.offerLetterMsg.offerKind === 'ESigGenerated' || $scope.offerLetterMsg.offerKind === 'ESigUploaded'){

                    for(let x in $scope.first.attachments){
                        $scope.first.attachmentList.push(x);
                    }
                    for(let x in $scope.secondAttachments){
                        $scope.second.attachmentList.push(x);
                    }

                    //agency user is CC'd by default in case of agency applications.
                    if($scope.first.agencyUser) {
                        $scope.first.bccList.push($scope.first.agencyUser.EId);
                    }
                    if ($scope.first.bcc) {
                      for (let j = 0; j < $scope.first.bcc.length; j++) {
                        $scope.first.bccList.push($scope.first.bcc[j].EId);
                        if ($scope.showDoubleForm) {
                            $scope.second.bccList.push($scope.first.bcc[j].EId); // First and Second forms have CC field linked/global.
                        }
                      }
                    }
                    if ($scope.showDoubleForm) {
                        $scope.second.ccToOfferCompletion = $scope.first.ccToOfferCompletion; // First and Second forms have Notify checkbox linked/global.
                    }

                    if ($scope.second.agencyUser) {
                      $scope.second.bccList.push($scope.second.agencyUser.EId);
                    }
                    if (!$scope.showDoubleForm && $scope.second.bcc) {
                      for (var j = 0; j < $scope.second.bcc.length; j++) {
                        $scope.second.bccList.push($scope.second.bcc[j].EId);
                      }
                    }

                    delete $scope.first.attachments;
                    delete $scope.first.bcc;
                    delete $scope.first.firstName;
                    delete $scope.first.lastName;
                    delete $scope.second.attachments;
                    delete $scope.second.bcc;
                    delete $scope.second.firstName;
                    delete $scope.second.lastName;

                    if ($scope.selectedSigningOrder === 'candidate') {
                        data.candidate = $scope.first;
                        data.company = $scope.second;
                    } else {
                        data.candidate = $scope.second;
                        data.company = $scope.first;
                    }

                    delete data.attachmentList;
                    delete data.bccList;
                    delete data.ccToOfferCompletion;
                    delete data.content;
                    delete data.subject;
                    delete data.toList;

                    if (!$scope.showDoubleForm) {
                        data = $scope.second;
                    }

                    candidates.sendESigOfferLetter($routeParams.applicationId, $routeParams.stateId, data, function(res){
                        $scope.flags.loading=false;
                        if( res.msgInfo === 200){
                            jvHireUrlService.loadCandidateDetailsTab('workflow',$routeParams.applicationId);
                            $scope.showMsg('OFFER_LETTER_SENT');
                            $scope.getApplicationDetails(true);
                        }else {
                            if($scope.jobviteEsignEnabled){
                                //Jobvite eSign
                                eSignErrorMessageModal(i18n.JOBVITE_ESIGN_MODAL_ERROR_TITLE, i18n.JOBVITE_ESIGN_MODAL_ERROR_MESSAGE);
                            }else{
                                //default Docusign
                                if(res.msgInfo === 401){
                                    if(window.enabledDocusignOAuth2 && window.enabledDocusignOAuth2 === 'true'){
                                        eSignErrorMessageModal(i18n.DOCUSIGN_MODAL_RE_AUTH_REQUEST, i18n.DOCUSIGN_MODAL_RE_AUTH_MESSAGE);
                                    } else {
                                        $scope.myaccountDocuSign = true;
                                    }
                                } else if(res.msgInfo === 500){
                                    eSignErrorMessageModal(i18n.DOCUSIGN_MODAL_ERROR_TITLE, i18n.DOCUSIGN_MODAL_ERROR_INTERNAL);
                                } else {
                                    eSignErrorMessageModal(i18n.DOCUSIGN_MODAL_ERROR_TITLE, res.msgError + '. ' + i18n.DOCUSIGN_MODAL_ERROR_MESSAGE);
                                }
                           }
                        }
                    });
                }else{
                    candidates.sendOfferLetter($routeParams.applicationId, $routeParams.stateId, data, function(res){
                        if(res.msgInfo === 200)
                        {
                            jvHireUrlService.loadCandidateDetailsTab('workflow',$routeParams.applicationId);
                            $scope.showMsg('OFFER_LETTER_SENT');
                            $scope.getApplicationDetails(true);
                        }
                    });
                }
            };

            function eSignErrorMessageModal(errorTitle, errorMessage) {
                $scope.modal.show = true;
                $scope.modal.title = errorTitle;
                $scope.modal.body = errorMessage;
                //$scope.modal.buttons = [];
                $scope.modal.buttons = [{
                    'class': 'btn',
                    'label': i18n.OK,
                    'click': function() {
                        $scope.modal.show = false;
                    }
                }];
            }
    }]);